import 'css-chunksrc/client/common/secondaryCriteriaTemplatePlaceholder/styles.scss';export default {
  "placeholder": "_placeholder_sy10w_1",
  "header": "_header_sy10w_8",
  "title": "_title_sy10w_15",
  "message": "_message_sy10w_21",
  "list": "_list_sy10w_27",
  "criteria": "_criteria_sy10w_37",
  "icon": "_icon_sy10w_51",
  "name": "_name_sy10w_57"
};